import React, { useState, useEffect, Fragment, useRef } from "react";
import groupService from "../../../Group/services";
import service from '../services';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { PageHeader } from "../../../../Common";
import Joi from "@hapi/joi";
import { validateProperty, validate } from "../../../Common";
import FormHelperText from "@material-ui/core/FormHelperText";
import "react-datepicker/dist/react-datepicker.css";
import { WorkedInactiveEmployeeSchema } from "../workedInactiveEmployeeReportSchema";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import authService from "../../../Common/services";
import tokenService from "../../../../Common/tokenDecoder";
import "../../../Common/Table/table.css";
import MessageModal from "../../../../UI/Modal/MessageModal";
import TextField from "@material-ui/core/TextField";
import ReactToPrint from "react-to-print";
import ComponentToPrint from "./createPdf";
import xlsx from 'json-as-xlsx';
import { InputAdornment, Box } from '@material-ui/core';
import Search from '@mui/icons-material/Search';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';

const screenCode = "WORKEDINACTIVEEMPLOYEEREPORT";

export function WorkedInactiveEmployeeReport(props) {
  const componentRef = useRef();

  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [divisions, setDivisions] = useState([]);

  const [searchData, setsearchData] = useState({
    groupID: "0",
    estateID: "0",
    divisionID: "0",
    fromDate: new Date().toISOString().split('T')[0],
    toDate: new Date().toISOString().split('T')[0],
  });

  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed Success",
  });

  const [isViewTable, setIsViewTable] = useState(true);
  const [errors, setErrors] = useState({});

  const schema = Joi.object(WorkedInactiveEmployeeSchema).options({
    allowUnknown: true,
  });

  const [reportData, setReportData] = useState([]);
  const [csvData, setCsvData] = useState([]);

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [searchDataForPrint, setSearchDataForPrint] = useState({
    group: "",
    estate: "",
    division: "",
    fromDate: "",
    toDate: "",
  });

  const [customSearch, setCustomSearch] = useState({
    empNumber: ''
  });
  const [filteredReportData, setFilteredReportData] = useState([]);

  const csvHeaders = [
    { label: "Date", value: "date" },
    { label: "Registered Division", value: "registerdDivision" },
    { label: "Worked Division", value: "workedDivision" },
    { label: "Employee Number", value: "employeeNumber" },
    { label: "Employee Name", value: "employeeName" },
    { label: "Work Type", value: "workType" },
    { label: "Operator", value: "operator" },
    { label: "Job Code", value: "jobCode" },
    { label: "Work Qty", value: "workQty" },
    { label: "Man Day", value: "manDay" },
    { label: "OT", value: "ot" },
    { label: "Estate Management's Review", value: "reviewStatus" }
  ];
  const [multipleEstates, setMultipleEstates] = useState({});
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  useEffect(() => {
    trackPromise(getEstatesByGroupID());
  }, [searchData.groupID]);

  useEffect(() => {
    trackPromise(getDivisionsByEstateID());
  }, [searchData.estateID]);

  useEffect(() => {
    if (reportData.length > 0 && !isViewTable) {
      handleCustomSearch(customSearch.empNumber);
    }
  }, [customSearch.empNumber]);

  useEffect(() => {
    setLimit(10);
    setPage(0);
  }, [searchData.divisionID, searchData.fromDate, searchData.toDate]);

  function handleCustomSearch(searchValue) {
    if (!searchValue || searchValue === '') {
      setFilteredReportData(reportData);
    } else {
      const filtered = reportData.filter(row => {
        let reviewStatus = "";
        if (row.employeeApprovelStatusID === 1) reviewStatus = "Pending";
        else if (row.employeeApprovelStatusID === 2) reviewStatus = "Approved";
        else if (row.employeeApprovelStatusID === 3) reviewStatus = "Rejected";

        return (
          row.employeeNumber?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.employeeName?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.registerdDivision?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.workedDivision?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.workType?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.operator?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.jobCode?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.date?.split("T")[0].includes(searchValue) ||
          reviewStatus.toLowerCase().includes(searchValue.toLowerCase())
        );
      });
      setFilteredReportData(filtered);
    }
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWWORKEDINACTIVEEMPLOYEEREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {
      var estateObject = {};
      for (let item of Object.entries(token.operationEntities)) {
        estateObject[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"];
      }
      setMultipleEstates(estateObject);
      setsearchData({
        ...searchData,
        groupID: token.groupID
      });
    } else {
      setsearchData({
        ...searchData,
        groupID: token.groupID,
        estateID: token.operationEntityID,
      });
    }

    setsearchData({
      ...searchData,
      groupID: token.groupID,
      estateID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropDown());
  }

  async function getGroupsForDropDown() {
    const groupsList = await groupService.getGroupsForDropdown();
    setGroups(groupsList);
  }

  async function getEstatesByGroupID() {
    const estateList = await service.getEstatesByGroupID(searchData.groupID);
    setEstates(estateList);
  }

  async function getDivisionsByEstateID() {
    const divisionList = await service.getDivisionsByEstateID(
      searchData.estateID
    );
    setDivisions(divisionList);
  }

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  function handleChange(e) {
    e.preventDefault();

    setReportData([]);
    setFilteredReportData([]);
    setCustomSearch({ empNumber: '' });
    setIsViewTable(true);

    const target = e.target;
    const value = target.value;
    const name = target.name;

    const error = { ...errors };
    const errorMessage = validateProperty(target, WorkedInactiveEmployeeSchema);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    if (name === 'groupID') {
      setsearchData({
        ...searchData,
        groupID: value,
        estateID: "0",
        divisionID: "0",
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
      });
    } else if (name === 'estateID') {
      setsearchData({
        ...searchData,
        estateID: value,
        divisionID: "0",
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
      });
    } else if (name === 'divisionID') {
      setsearchData({
        ...searchData,
        divisionID: value,
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
      });
    } else {
      setsearchData({
        ...searchData,
        [name]: value,
      });
    }

    setErrors(error);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleCustomSearchChange(e) {
    setCustomSearch({
      ...customSearch,
      empNumber: e.target.value
    });
  }

  async function handleSearch(e) {
    const errorMessages = validate(schema, searchData);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    setReportData([]);
    setFilteredReportData([]);
    setCustomSearch({ empNumber: '' });
    setPage(0);
    setIsViewTable(true);

    let data = {
      groupID: parseInt(searchData.groupID),
      estateID: parseInt(searchData.estateID),
      divisionID: parseInt(searchData.divisionID),
      fromDate: searchData.fromDate,
      toDate: searchData.toDate,
    };
    const reportDataResponse = await service.getWorkedInactiveEmployeeReportData(data);
    if (reportDataResponse != null && reportDataResponse.length > 0) {
      const enhancedData = reportDataResponse.map(row => {
        let reviewStatus = "";
        if (row.employeeApprovelStatusID === 1) reviewStatus = "Pending";
        else if (row.employeeApprovelStatusID === 2) reviewStatus = "Approved";
        else if (row.employeeApprovelStatusID === 3) reviewStatus = "Rejected";

        return {
          ...row,
          reviewStatusText: reviewStatus
        };
      });

      setReportData(enhancedData);
      setFilteredReportData(enhancedData);
      setIsViewTable(false);
      createDataForPrint(data);
      createCSVData(enhancedData);
    } else {
      setReportData([]);
      setFilteredReportData([]);
      setIsViewTable(true);
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: "Warning",
        disciption: "No records found for the selected criteria",
      });
      setTimeout(() => {
        modalDismissHandler();
      }, 2000);
    }
  }

  function createDataForPrint(searchData) {
    setSearchDataForPrint({
      group: groups[searchData.groupID],
      estate: estates[searchData.estateID],
      division: searchData.divisionID === 0 ? "All" : divisions[searchData.divisionID],
      fromDate: searchData.fromDate,
      toDate: searchData.toDate,
    });
  }

  function createCSVData(reportData) {
    const csvDataArray = reportData.map((row) => {
      let reviewStatus = "";
      if (row.employeeApprovelStatusID === 1) reviewStatus = "Pending";
      else if (row.employeeApprovelStatusID === 2) reviewStatus = "Approved";
      else if (row.employeeApprovelStatusID === 3) reviewStatus = "Rejected";

      return {
        date: row.date ? row.date.split("T")[0] : "",
        registerdDivision: row.registerdDivision,
        workedDivision: row.workedDivision,
        employeeNumber: row.employeeNumber,
        employeeName: row.employeeName,
        workType: row.workType,
        operator: row.operator,
        jobCode: row.jobCode,
        workQty: row.workQty,
        manDay: row.manDay,
        ot: row.ot,
        reviewStatus: reviewStatus
      };
    });
    setCsvData(csvDataArray);
  }

  function createExcelFile() {
    var copyOfCsv = [...csvData];

    copyOfCsv.push({});

    var filterRow1 = {
      date: "Group: " + groups[searchData.groupID],
      registerdDivision: "Operation Entity: " + estates[searchData.estateID],
      workedDivision: "Collection Point: " + (searchData.divisionID === "0" ? "All" : divisions[searchData.divisionID])
    };

    var filterRow2 = {
      date: "From Date: " + searchData.fromDate,
      registerdDivision: "To Date: " + searchData.toDate
    };

    copyOfCsv.push(filterRow1, filterRow2);
    var settings = {
      sheetName: 'Worked Inactive Employee Report',
      fileName: 'WorkedInactiveEmployeeReport',
      writeOptions: {}
    }
    xlsx(csvHeaders, copyOfCsv, settings, true);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function clearData() {
    setsearchData({
      ...searchData,
      divisionID: "0",
      fromDate: "",
      toDate: "",
    });
    setReportData([]);
    setFilteredReportData([]);
    setCustomSearch({ empNumber: '' });
    setPage(0);
    setLimit(10);
    setIsViewTable(true);
    setErrors({});
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Worked Inactive Employee Report"
              isButtonEnable={false}
            />
            <div className="card-body">
              <form>
                <div className="form-group row">
                  <div className="col-md-4 pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="groupID"
                      disabled={!permissionList.isGroupFilterEnabled}
                      name="groupID"
                      value={searchData.groupID}
                      onChange={(e) => handleChange(e)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText className="text text-danger">
                        {errors["groupID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md-4 pb-1">
                    <InputLabel shrink id="estateID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="estateID"
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      name="estateID"
                      value={searchData.estateID}
                      onChange={(e) => handleChange(e)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(
                        Object.keys(multipleEstates).length === 0 ? estates : multipleEstates
                      )}
                    </Select>
                    {errors["estateID"] && (
                      <FormHelperText className="text text-danger">
                        {errors["estateID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md-4 pb-1">
                    <InputLabel shrink id="divisionID">
                      Collection Point
                    </InputLabel>
                    <Select
                      fullWidth
                      id="divisionID"
                      name="divisionID"
                      value={searchData.divisionID}
                      onChange={(e) => handleChange(e)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(divisions)}
                    </Select>
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-md-4 pb-1">
                    <TextField
                      id="fromDate"
                      label="From Date *"
                      name="fromDate"
                      type="date"
                      fullWidth
                      value={searchData.fromDate}
                      onChange={(e) => handleChange(e)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        max: new Date().toISOString().split('T')[0]
                      }}
                    />
                    {errors["fromDate"] && (
                      <FormHelperText className="text text-danger">
                        {errors["fromDate"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md-4 pb-1">
                    <TextField
                      id="toDate"
                      label="To Date *"
                      name="toDate"
                      type="date"
                      fullWidth
                      value={searchData.toDate}
                      onChange={(e) => handleChange(e)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        max: new Date().toISOString().split('T')[0]
                      }}
                    />
                    {errors["toDate"] && (
                      <FormHelperText className="text text-danger">
                        {errors["toDate"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md-4 pb-1"></div>
                </div>

                <div className="form-group row">
                  <div className="col-md pb-1">
                    <input
                      type="button"
                      className="btn btn-primary mr-2"
                      value="Generate"
                      disabled={validate(schema, searchData)}
                      onClick={(e) => handleSearch(e)}
                    />
                    <input
                      type="reset"
                      className="btn btn-warning pull-right"
                      value="Clear"
                      onClick={() => clearData()}
                    />
                  </div>
                </div>
              </form>

              {!isViewTable && (
                <Fragment>
                  <Box display="flex" flexDirection="row-reverse" p={2}>
                    <TextField
                      size="small"
                      style={{ width: '300px' }}
                      placeholder="Search"
                      onChange={(e) => handleCustomSearchChange(e)}
                      value={customSearch.empNumber}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>

                  <div>
                    {filteredReportData.length !== 0 ? (
                      <Card>
                        <TableContainer component={Paper}>
                          <div className="row alternative_cls bg-light">
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Date</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Registered Division</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Worked Division</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Number</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Work Type</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Operator</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Job Code</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Work Qty</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Man Day</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>OT</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Estate Management's Review</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {filteredReportData
                                  .slice(page * limit, page * limit + limit)
                                  .map((row, index) => (
                                    <TableRow key={index}>
                                      <TableCell align="center">{row.date ? row.date.split("T")[0] : ""}</TableCell>
                                      <TableCell align="left">{row.registerdDivision}</TableCell>
                                      <TableCell align="left">{row.workedDivision}</TableCell>
                                      <TableCell align="left">{row.employeeNumber}</TableCell>
                                      <TableCell align="left">{row.employeeName}</TableCell>
                                      <TableCell align="left">{row.workType}</TableCell>
                                      <TableCell align="left">{row.operator}</TableCell>
                                      <TableCell align="left">{row.jobCode}</TableCell>
                                      <TableCell align="center">{row.workQty}</TableCell>
                                      <TableCell align="center">{row.manDay}</TableCell>
                                      <TableCell align="center">{row.ot}</TableCell>
                                      <TableCell
                                        align="center"
                                        style={{
                                          backgroundColor:
                                            row.employeeApprovelStatusID === 1
                                              ? "#f69f1cff"
                                              : row.employeeApprovelStatusID === 2
                                                ? "#4caf50"
                                                : row.employeeApprovelStatusID === 3
                                                  ? "#f44336"
                                                  : "transparent",
                                          color: "#000000",
                                          fontWeight: "500"
                                        }}
                                      >
                                        {row.employeeApprovelStatusID === 1 && "Pending"}
                                        {row.employeeApprovelStatusID === 2 && "Approved"}
                                        {row.employeeApprovelStatusID === 3 && "Rejected"}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </div>
                        </TableContainer>
                        <TablePagination
                          component="div"
                          count={filteredReportData.length}
                          onChangePage={handlePageChange}
                          onChangeRowsPerPage={handleLimitChange}
                          page={page}
                          rowsPerPage={limit}
                          rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        />
                      </Card>
                    ) : null}

                    {filteredReportData.length > 0 ? (
                      <div className="pt-2">
                        <input
                          type="button"
                          className="btn btn-primary pull-right ml-2"
                          value="Excel"
                          onClick={createExcelFile}
                        />
                        <ReactToPrint
                          documentTitle={"Worked Inactive Employee Report"}
                          trigger={() => (
                            <input
                              type="button"
                              className="btn btn-primary pull-right ml-2"
                              value="PDF"
                            />
                          )}
                          content={() => componentRef.current}
                        />
                      </div>
                    ) : null}

                    <div hidden={true}>
                      <ComponentToPrint
                        ref={componentRef}
                        searchData={searchDataForPrint}
                        data={reportData}
                      />
                    </div>
                  </div>
                </Fragment>
              )}
            </div>

          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
      />
    </Fragment>
  );
}